export default {"src":"/_next/static/media/team-ic.4ef57239.svg","height":20,"width":15,"blurWidth":0,"blurHeight":0};